<template>
  <div class="personal">
    <img src="@/assets/mine/personal_top@2x.png" alt="" class="top_bg" />
    <div class="persional_con">
      <div class="clearfix">
        <div class="left left_per">
          <img
            :src="getUserInfo.avatarUrl || avatarImg"
            alt=""
            class="per_photo"
            @click="goCenter"
          />
          <div
            class="per_name font14 font_weight500 text_left"
            @click="goCenter"
          >
            <span>{{ getUserInfo.username }}</span>
          </div>
        </div>
        <!-- <img src="@/assets/mine/message@2x.png" alt="" class="per_set right" /> -->
        <!-- <img src="@/assets/mine/setting@2x.png" alt="" class="per_set right" /> -->
      </div>
      <div class="per_ticket">
        <div class="ticket_item" @click="showToast">
          <div class="font20 font_weight600  ticket_num">--</div>
          <div class="font10 font_weight500">优惠券</div>
        </div>
        <div class="ticket_item" @click="goCardList">
          <div class="font20 font_weight600 ticket_num">
            {{ getUserInfo.cardVoucherNum || "--" }}
          </div>
          <div class="font10 font_weight500">礼品卡</div>
          <div class="right_line"></div>
        </div>
        <div class="ticket_item" @click="showToast">
          <div class="font20 font_weight600 ticket_num">--</div>
          <div class="font10 font_weight500">收藏</div>
          <div class="right_line"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      avatarImg: require("@/assets/mine/per_photo@2x.png")
    };
  },
  computed: {
    getUserInfo() {
      return this.$store.getters.getUserInfo;
    }
    // queryCardVoucherUserCount() {
    //   return this.$store.getters.queryCardVoucherUserCount;
    // }
  },
  methods: {
    goCenter() {
      this.$router.push("/mine/personalcenter");
    },
    goCardList() {
      this.$router.push("/mine/cardpackagelist");
    },
    showToast() {
      this.$toast("敬请期待");
    }
  }
};
</script>
<style lang="less" scoped>
.personal {
  color: #fff;
  position: relative;
  z-index: 0;
  width: 100%;
  .top_bg {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -10;
  }
  .persional_con {
    padding: 16px 12px 0 15px;
    .left_per {
      display: flex;
      align-items: center;
    }
    .per_photo {
      width: 54px;
      height: 54px;
      border: 3px solid rgba(255, 255, 255, 0.5);
      border-radius: 50%;
    }
    .per_name {
      max-width: 200px;
      line-height: 24px;
      margin-left: 12px;
      .right_icon {
        vertical-align: middle;
        width: 24px;
      }
    }
    .per_set {
      width: 24px;
      display: block;
      margin-left: 12px;
    }
    .per_ticket {
      margin-top: 12px;
      display: flex;
      .ticket_item {
        flex: 1;
        .ticket_num {
          margin-bottom: 1px;
        }
        .right_line {
          width: 1px;
          height: 15px;
          background: #fff;
          border-radius: 1px;
          opacity: 0.55;
          margin-top: -25px;
        }
      }
    }
  }
}
</style>
